import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class IsRecovery extends Decision {
    public evaluate() {
        return GameState.getCurrentGame() && GameState.getCurrentGame().isRecovered ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/decisions/is-recovery.ts